<template>
  <div class="container">
    <div class="wrap">
      <div class="title">
        <div class="return" @click="returnArrange">
          <i class="el-icon-arrow-left"></i>返回
        </div>
        <div class="titleText">
          <i class="el-icon-location"></i>
          {{ text }}-发布调度
        </div>
      </div>
      <div class="content">
        <div class="contentItem">
          <div class="label">督察工地：</div>
          <div class="input">
            <!-- <el-input v-model="site" placeholder="请填写工地"></el-input> -->
            <el-select
              clearable
              @change="sitechange"
              v-model="searchedLocation"
              filterable
              placeholder="请选择工地"
            >
              <el-option
                v-for="item in sitedata"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </div>
          <!-- <div class="hasIcons" @click="locationListVisible = true">
            <img src="../../assets/img/event/list.png" alt />
          </div>-->
        </div>
        <div class="contentItem">
          <div class="label">督察小组：</div>
          <div class="input">
            <el-select
              v-model="toGroup"
              @change="groupchange"
              placeholder="请选择"
            >
              <el-option
                v-for="item in groupdata"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </div>
          <div class="positionText">{{ caledText }}</div>
        </div>
        <div class="contentItem">
          <div class="label">调度类型：</div>
          <div class="input">
            <el-radio-group @change="radiochange" v-model="radio">
              <el-radio label="1">日常调度</el-radio>
              <el-radio label="2">紧急调度</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="contentItem">
          <div class="label">指定阅读：</div>
          <div class="input">
            <el-select
              multiple
              v-model="department"
              @change="readchange"
              placeholder="请选择"
            >
              <el-option
                v-for="item in readdata"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="contentItem">
          <div class="label">突发情况处置：</div>
          <div class="input">
            <el-radio-group @change="exceptionchange" v-model="exceptionRadio">
              <el-radio label="1">无异常</el-radio>
              <el-radio label="2">有异常</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="contentItem">
          <div class="label">置顶：</div>
          <div class="input">
            <el-radio-group @change="topflagchange" v-model="topflag">
              <el-radio label="0">不置顶</el-radio>
              <el-radio label="1">置顶</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="contentItem">
          <div class="label"></div>
          <div class="button" @click="open">确认发布</div>
        </div>
      </div>
    </div>
    <!-- <list-popup
      @selectedLocation="selectedLocation"
      :locationListVisible="locationListVisible"
      @dialog-cancel="locationListVisible=false"
    ></list-popup>-->
  </div>
</template>

<script>
// import ListPopup from "@/components/common/popups/ListPopup";
import { mapState, mapGetters } from "vuex";
import { APIMAP } from "@/constants/apiConstants";
import { getServerData } from "@/utils/fetchData";
export default {
  // components: {
  //   ListPopup
  // },
  name: "pubArrange",
  data() {
    return {
      locationListVisible: false,
      from: "",
      text: "",
      searchedLocation: "",
      toGroup: "",
      department: "",
      radio: "1",
      exceptionRadio: "1",
      sitedata: "",
      groupdata: "",
      readdata: "",
      response: "",
      process: "",
      topflag: "0",
      nowGroupItem: {},
    };
  },
  props: {},
  computed: {
    ...mapState(["userInfo"]),
    ...mapGetters(["canPublishSupervise"]),
    caledText() {
      if (this.process && this.response) {
        return `该督查组位为专责组，响应时间${this.process}分钟，处置事件${this.response}分钟`;
      } else {
        return "";
      }
    },
  },
  mounted() {
    if (!this.canPublishSupervise) {
      this.$nv("/404");
    }
    this.from = this.$route.query.from;
    if (this.from === "superviseArrange") {
      this.text = "督察调度";
    } else {
      this.text = "首页";
    }
    this.getselectdata();
  },
  methods: {
    sitechange(e) {
      this.searchedLocation = e;
      this.getGroupData(this.searchedLocation);
    },
    groupchange(e) {
      this.toGroup = e;
      this.nowGroupItem = this.groupdata.find((it) => it.name == e);
      console.log(this.nowGroupItem);
      if (this.nowGroupItem) {
        this.process = this.nowGroupItem.process;
        this.response = this.nowGroupItem.response;
      }
    },
    readchange(e) {
      this.department = e;
    },
    radiochange(e) {
      this.radio = e;
    },
    exceptionchange(e) {
      this.exceptionRadio = e;
    },
    topflagchange(e) {
      this.topflag = e;
    },
    returnArrange() {
      this.$nv(`/${this.from}`);
    },
    async getselectdata() {
      console.log("00000", this.userInfo);
      try {
        const dustres = await getServerData(
          APIMAP.GET_RESOURCE_TYPE,
          {
            gid: this.userInfo.platformid,
            mini: 1,
            size: 1000000,
          },
          "get"
        );
        const groupres = await getServerData(
          APIMAP.GET_DEPARTMENT,
          {
            pid: this.userInfo.platformid,
            type: "2",
          },
          "get"
        );
        const specialres = await getServerData(
          APIMAP.GET_DEPARTMENT,
          {
            pid: this.userInfo.platformid,
            type: "3",
          },
          "get"
        );
        const readres = await getServerData(
          APIMAP.GET_DEPARTMENT,
          {
            pid: this.userInfo.platformid,
            // type: "1",
          },
          "get"
        );
        console.log("列表", groupres, specialres);
        this.sitedata = dustres.data;
        this.groupdata = groupres;
        this.readdata = readres;
        console.log(this.sitedata);
      } catch (e) {
        console.log(e);
      }
    },
    async getGroupData(construction) {
      try {
        const res = await getServerData(
          APIMAP.GET_DEPARTMENT,
          {
            pid: this.userInfo.platformid,
            type: "2",
            construction,
          },
          "get"
        );
        this.groupdata = res;
        this.process = "";
        this.response = "";
        this.toGroup = "";
        this.nowGroupItem = {};
        console.log(res);
      } catch (e) {
        console.log(e);
      }
    },
    open() {
      this.$confirm("是否提交?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.UpLoad();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    async UpLoad() {
      console.log(this.userInfo);
      // YangChang 不校验 f
      if (!this.toGroup || !this.searchedLocation) {
        this.$message.error("督查工地与督查小组为必填项");
        return;
      }
      try {
        const param = {
          construction: this.searchedLocation,
          inspection: this.toGroup,
          response: this.response,
          type: this.radio,
          depts: this.department.join(","),
          burst: this.exceptionRadio,
          pid: this.userInfo.platformid,
          processing: this.process,
          uid: this.userInfo.gid,
          istop: this.topflag,
          username: this.userInfo.realname,
        };
        console.log(param);
        const res = await getServerData(APIMAP.DISPATCH, param, "post");
        console.log(res);
        this.$message({
          type: "success",
          message: "提交成功!",
        });
        if (this.from === "superviseArrange") {
          this.$router.push({ name: "SuperviseArrange" });
        } else {
          this.$router.push({ name: "tipdetail" });
        }
      } catch (e) {
        this.$message.error("提交失败");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  box-sizing: border-box;
  padding: 24px 26px;
  width: 100%;
  .wrap {
    background: #fff;
    height: 850px;
    font-size: 16px;
    color: #99a9ba;
    padding: 24px 27px;
    box-sizing: border-box;

    .title {
      display: flex;
      border-bottom: 1px solid #e2e5ec;
      padding-bottom: 18px;
      .return {
        cursor: pointer;
      }
      .titleText {
        margin-left: 23px;
      }
    }

    .content {
      margin-top: 30px;
      border-bottom: 1px solid #e2e5ec;
      min-height: 640px;

      .contentItem {
        display: flex;
        margin-bottom: 24px;
        position: relative;
        &:nth-child(1) {
          &:before {
            content: "*";
            color: red;
            position: absolute;
            top: 12px;
            left: -10px;
            font-size: 12px;
          }
        }
        &:nth-child(2) {
          margin-bottom: 40px;
          position: relative;
          &:before {
            content: "*";
            color: red;
            position: absolute;
            top: 12px;
            left: -10px;
            font-size: 12px;
          }
        }
        .label {
          color: #394259;
          width: 120px;
          line-height: 40px;
        }

        .button {
          width: 150px;
          height: 42px;
          background: #009157;
          border-radius: 5px;
          text-align: center;
          line-height: 42px;
          color: #fff;
          margin-top: 10px;
          cursor: pointer;
        }

        .input,
        .el-select {
          width: 385px;
          line-height: 40px;
        }

        .positionText {
          position: absolute;
          font-size: 12px;
          color: #838997;
          bottom: -25px;
          left: 120px;
        }

        .hasIcons {
          img {
            cursor: pointer;
            width: 40px;
            margin: 0 0 0 10px;
          }
        }
      }
    }
  }
}
</style>